import { Injectable } from '@angular/core';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { Observable } from 'rxjs';
import { AvailableSpeedResource } from '@dch/products-business-logic';
import { AvailableSpeedEntity } from '../configs/entity.config';

@Injectable({
  providedIn: 'root',
})
export class AvailableSpeedService {
  constructor() {}

  getAvailableSpeed(payload: any): Observable<IEntity<AvailableSpeedResource>> {
    return EntityManager.getEntity(AvailableSpeedEntity, {
      serviceId: payload.serviceId,
    });
  }
}
